import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import { MediaDto } from "../../interfaces/media";

export const subjectNoteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubjectNotes: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/subject-note"),
      }),
      providesTags: ["Paginated-Subject-Notes"],
    }),
    getSubjectNote: builder.query<any, string>({
      query: (id) => ({ url: `/api/subject-note/${id}` }),
      providesTags: ["SubjectNote"],
    }),
    addSubjectNote: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/subject-note",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Subject-Notes"],
    }),
    updateSubjectNote: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/subject-note/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["SubjectNote", "Paginated-Subject-Notes"],
    }),
    deleteSubjectNote: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/subject-note/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Subject-Notes"],
    }),
    toggleSubjectNote: builder.mutation<any, string>({
      query: (noteId) => ({
        url: `/api/subject-note/toggle-state/${noteId}`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["SubjectNote", "Paginated-Subject-Notes"],
    }),
    uploadSubjectNote: builder.mutation<
      MediaDto,
      {
        file: File;
        subjectNoteId?: string | null;
        onProgress?: (progress: number) => void;
      }
    >({
      query: ({ file, subjectNoteId, onProgress }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: subjectNoteId
            ? `/api/subject-note/upload?id=${subjectNoteId}`
            : "/api/subject-note/upload",
          method: "POST",
          data: formData,
          onUploadProgress: (event: any) => {
            if (event.total && onProgress) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          },
        };
      },
      invalidatesTags: ["SubjectNote"],
    }),
    downloadSubjectNote: builder.mutation<Blob, string>({
      query: (noteId) => ({
        url: `/api/subject-note/download/${noteId}`,
        responseType: "blob",
      }),
    }),
  }),
});

export const {
  useGetSubjectNotesQuery,
  useGetSubjectNoteQuery,
  useAddSubjectNoteMutation,
  useUpdateSubjectNoteMutation,
  useDeleteSubjectNoteMutation,
  useToggleSubjectNoteMutation,
  useUploadSubjectNoteMutation,
  useDownloadSubjectNoteMutation,
} = subjectNoteApi;
